import { CreativeWorkbenchProvider } from '@/pages/creative/CreativeWorkbenchContext';
import { PersonaDetailView } from '@/pages/creative/PerformanceView/PersonaDetailView';

/**
 * Mounts the existing Creative Workbench PersonaDetailView under the new
 * `/performance/personas/:personaId` route. The wrapper supplies the
 * CreativeWorkbenchProvider context the component depends on.
 */
export function PersonaDetailViewStandalone() {
  return (
    <CreativeWorkbenchProvider>
      <PersonaDetailView />
    </CreativeWorkbenchProvider>
  );
}

export default PersonaDetailViewStandalone;
